module.exports = __webpack_public_path__ + "static/@MACAWByStories-708d21af7d839734d66f66e848a1b452.jpg";